// @ts-ignore
export * from './insertRoles.gql'
// @ts-ignore
export * from './deleteRoles.gql'
